import { useNotify, useRecordContext } from 'react-admin';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import { PillButtonField } from '@/components/fields';
import { SOURCE_TO_COLOR_MAP, SOURCE_TO_VALUE_MAP } from './constants';
import { ConditionalFieldProps } from './types';
import { TextFieldStyled } from './styled';

const ConditionalTextField = ({ label, renderPill = false, source, ...props }: ConditionalFieldProps) => {
  const notify = useNotify();
  const record = useRecordContext();
  const value = get(record, source);

  return (
    <CopyToClipboard onCopy={() => notify(`${label || startCase(source)} copied to clipboard`)} text={value}>
      {renderPill ? (
        <PillButtonField
          source={source}
          valueMap={SOURCE_TO_VALUE_MAP[source]}
          colorMap={SOURCE_TO_COLOR_MAP[source]}
        />
      ) : (
        <TextFieldStyled source={source} {...props} />
      )}
    </CopyToClipboard>
  );
};

export default ConditionalTextField;
